import React from 'react'

import { InlineSelect } from '../scharedStyles/style'

const filterOption = (input, option) =>
    String(option?.label || '')
        .toLowerCase()
        .includes(String(input || '').toLowerCase())

const normalizeSelectValue = (value, multiple) => {
    if (multiple) {
        if (!Array.isArray(value)) return []

        return value
            .filter((item) => item !== undefined && item !== null && item !== '')
            .map((item) => String(item))
    }

    if (value === undefined || value === null || value === '') {
        return undefined
    }

    return String(value)
}

const FormSelect = ({
    value,
    options,
    placeholder,
    onChange,
    multiple = false,
    disabled = false,
}) => (
    <InlineSelect
        showSearch
        allowClear
        mode={multiple ? 'multiple' : undefined}
        value={normalizeSelectValue(value, multiple)}
        placeholder={placeholder}
        options={options}
        optionFilterProp="label"
        filterOption={filterOption}
        disabled={disabled}
        onChange={onChange}
    />
)

export default FormSelect
